module.exports = '<svg width="37" height="32" viewBox="0 0 37 32"><path d="M4.571 2.286L0 22.857v6.857A2.284 2.284 0 0 0 2.286 32h32a2.284 2.284 0 0 0 2.286-2.286v-6.857L32.001 2.286A2.284 2.284 0 0 0 29.715 0H6.858a2.284 2.284 0 0 0-2.286 2.286zm20.572 18.285v2.286a2.284 2.284 0 0 1-2.286 2.286h-9.143a2.284 2.284 0 0 1-2.286-2.286v-2.286a2.284 2.284 0 0 0-2.286-2.286H6.856L9.142 4.571h18.286l2.286 13.714h-2.286a2.284 2.284 0 0 0-2.286 2.286z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/inbox-6.js
// module id = 1188
// module chunks = 14